import AccessLog, { accessLogPageSize } from '@gym-organisms/AccessLog/AccessLog';
import { UserRole } from '@gym-particles/types/User';
import { fetchActivity } from '@gym-redux/slices/activitySlice';
import { useAppDispatch, useAppSelector } from '@gym-redux/store';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

const accessDoorStageId = 3;
const allEventTypes = 'all';

const GymDashboardActivity = (props: GymDashboardActivityProps) => {
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state) => state.user.userId);
  const userRole = useAppSelector((state) => state.user.userRole);
  const currentGym = useAppSelector((state) =>
    state.gyms.items
      .find((gymChain) => gymChain.items.some((gym) => gym.gymId === props.gymId))
      ?.items.find((gym) => gym.gymId === props.gymId)
  );
  const isActivityLoading = useAppSelector((state) => state.activity.isActivityLoading);
  const activityItems = useAppSelector((state) =>
    state.activity.items.find((item) => item.siteLocationId === props.gymId)
  )?.activityItems;
  const [offset, setOffset] = useState(0);
  const [startingDate, setStartingDate] = useState<Date>(
    new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
  );
  const [endingDate, setEndingDate] = useState<Date>(new Date());
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    dispatch(
      fetchActivity({
        userId,
        siteLocationId: props.gymId,
        pageSize: accessLogPageSize,
        offset,
        dateFrom: `${dayjs(startingDate).format('YYYY-MM-DD')} 00:00:00`,
        dateTo: `${dayjs(endingDate).format('YYYY-MM-DD')} 23:59:59`,
        stageId: accessDoorStageId,
        eventType: allEventTypes,
        platformAdmin: userRole === UserRole.SYSTEM_ADMIN,
        timeZone: currentGym?.timeZone
      })
    );
  }, [
    currentGym?.timeZone,
    dispatch,
    endingDate,
    offset,
    props.gymId,
    refresh,
    startingDate,
    userId,
    userRole
  ]);

  return (
    <AccessLog
      gymId={props.gymId}
      activities={activityItems?.items || []}
      isLoading={isActivityLoading}
      totalActivityCount={activityItems?.totalRecords || 0}
      offset={offset}
      startingDate={startingDate}
      endingDate={endingDate}
      onOffsetChange={setOffset}
      onStartingDateChange={setStartingDate}
      onEndingDateChange={setEndingDate}
      onRefresh={() => setRefresh((currentRefresh) => !currentRefresh)}
      countChange={props.countChange}
      isCountChanged={props.isCountChanged}
    />
  );
};

export interface GymDashboardActivityProps {
  gymId: number;
  countChange?: (value: boolean) => void;
  isCountChanged?: boolean;
}

export default GymDashboardActivity;
